// Legal documents required by the App Store / Google Play review process.
const SUPPORT = "mentoriafabioborges@gmail.com";
const UPDATED = "2026-06";

export const LEGAL = {
  pt: {
    privacy: {
      title: "Política de Privacidade",
      updated: `Última atualização: ${UPDATED}`,
      sections: [
        ["Quem somos", [
          "O Skinly Check é um aplicativo de acompanhamento estético para pessoas em tratamento com medicamentos GLP-1. Não somos um serviço médico e não fornecemos diagnóstico.",
        ]],
        ["Dados que coletamos", [
          "Cadastro: nome, e-mail e senha (armazenada apenas de forma criptografada).",
          "Saúde e medidas informadas por você: peso, altura e IMC.",
          "Fotos que você envia para a análise estética (rosto e/ou corpo).",
          "Plataforma de compra (Hotmart ou Kiwify), quando sua conta é criada automaticamente após a compra.",
        ]],
        ["Como usamos seus dados", [
          "Gerar suas análises estéticas, laudos e gráficos de evolução.",
          "Autenticar seu acesso e manter sua sessão segura.",
          "Enviar e-mails operacionais (ativação de conta e redefinição de senha).",
          "Não vendemos, alugamos nem usamos seus dados ou fotos para publicidade.",
        ]],
        ["Fotos: como são tratadas", [
          "Suas fotos ficam em armazenamento privado e só podem ser acessadas pela sua própria conta autenticada.",
          "Para gerar o laudo, as fotos são enviadas ao provedor de inteligência artificial (OpenAI) exclusivamente para processar aquela análise. Elas não são usadas para treinar modelos.",
          "Você pode excluir qualquer avaliação, ou toda a sua conta e fotos, a qualquer momento dentro do app.",
          "Não analisamos imagens de nudez nem imagens de menores de 18 anos. Envios desse tipo são recusados automaticamente.",
        ]],
        ["Compartilhamento com terceiros", [
          "OpenAI — processamento da análise de imagens e textos.",
          "Resend — envio de e-mails transacionais.",
          "Hotmart e Kiwify — confirmação da sua compra para criação do acesso.",
          "Não há outro compartilhamento além dos estritamente necessários ao funcionamento do app.",
        ]],
        ["Retenção e exclusão", [
          "Mantemos seus dados enquanto sua conta existir.",
          "Em Conta → Excluir minha conta, todos os seus dados (fotos, laudos, registros de peso e IMC) são apagados de forma permanente e imediata.",
        ]],
        ["Seus direitos", [
          "Você pode acessar, corrigir, exportar (PDF) e excluir seus dados, conforme a LGPD (Brasil) e o GDPR (Europa).",
          `Para qualquer solicitação de privacidade, escreva para ${SUPPORT}.`,
        ]],
        ["Menores de idade", [
          "O aplicativo é destinado a pessoas com 18 anos ou mais. Não coletamos intencionalmente dados de menores.",
        ]],
        ["Segurança", [
          "Conexões criptografadas (HTTPS), senhas com hash bcrypt, sessão por cookie httpOnly e fotos em armazenamento privado.",
        ]],
        ["Contato", [`Dúvidas sobre privacidade: ${SUPPORT}`]],
      ],
    },
    terms: {
      title: "Termos de Uso",
      updated: `Última atualização: ${UPDATED}`,
      sections: [
        ["Aceitação", [
          "Ao criar sua conta e usar o Skinly Check, você concorda com estes Termos e com a Política de Privacidade.",
        ]],
        ["Natureza do serviço — não é diagnóstico médico", [
          "O app avalia exclusivamente aspectos estéticos visíveis em fotos, com apoio de inteligência artificial.",
          "O conteúdo é informativo e educacional. NÃO substitui consulta, diagnóstico ou tratamento médico, dermatológico ou nutricional.",
          "Nunca inicie, interrompa ou altere qualquer tratamento com base apenas no laudo do app. Procure um(a) profissional de saúde.",
        ]],
        ["Conteúdo que você envia", [
          "Você declara que as fotos enviadas são suas ou que você tem autorização expressa da pessoa retratada.",
          "É proibido enviar imagens de nudez (genitália, ânus ou mamilos expostos), conteúdo sexual, imagens de menores de 18 anos ou imagens de terceiros sem consentimento.",
          "Recomendamos fotos com roupa de banho ou roupas justas, em boa iluminação.",
          "Envios que violem estas regras são recusados e podem levar ao encerramento da conta.",
        ]],
        ["Sua conta", [
          "O acesso é pessoal e não transferível. Mantenha sua senha em sigilo.",
          "Você pode excluir sua conta e todos os seus dados a qualquer momento dentro do app.",
        ]],
        ["Limitação de responsabilidade", [
          "As análises são geradas por inteligência artificial a partir de imagens e podem conter imprecisões.",
          "Não nos responsabilizamos por decisões estéticas, clínicas ou financeiras tomadas com base no conteúdo do app.",
        ]],
        ["Propriedade intelectual", [
          "O nome, a marca, os textos e o software do Skinly Check são protegidos. Suas fotos e seus dados continuam sendo seus.",
        ]],
        ["Alterações", [
          "Podemos atualizar estes Termos para refletir melhorias do app ou exigências legais. A data de atualização sempre será exibida nesta página.",
        ]],
        ["Contato", [`Suporte: ${SUPPORT}`]],
      ],
    },
  },
  en: {
    privacy: {
      title: "Privacy Policy",
      updated: `Last updated: ${UPDATED}`,
      sections: [
        ["Who we are", [
          "Skinly Check is an aesthetic tracking app for people undergoing GLP-1 treatment. We are not a medical service and we do not provide diagnoses.",
        ]],
        ["Data we collect", [
          "Account: name, email and password (stored only as a hash).",
          "Measurements you enter: weight, height and BMI.",
          "Photos you upload for aesthetic analysis (face and/or body).",
          "Purchase platform (Hotmart or Kiwify) when your account is created automatically after a purchase.",
        ]],
        ["How we use your data", [
          "To generate your aesthetic assessments, reports and progress charts.",
          "To authenticate you and keep your session secure.",
          "To send operational emails (account activation and password reset).",
          "We never sell or rent your data, and we never use your photos for advertising.",
        ]],
        ["How photos are handled", [
          "Your photos are kept in private storage and can only be accessed by your own authenticated account.",
          "To produce a report, photos are sent to our AI provider (OpenAI) solely to process that analysis. They are not used to train models.",
          "You can delete any assessment, or your entire account and photos, at any time inside the app.",
          "We do not analyze nude images or images of people under 18. Such uploads are automatically refused.",
        ]],
        ["Third parties", [
          "OpenAI — image and text analysis processing.",
          "Resend — transactional email delivery.",
          "Hotmart and Kiwify — purchase confirmation to create your access.",
          "No sharing beyond what is strictly required to run the app.",
        ]],
        ["Retention and deletion", [
          "We keep your data for as long as your account exists.",
          "Under Account → Delete my account, all your data (photos, reports, weight and BMI records) is permanently and immediately erased.",
        ]],
        ["Your rights", [
          "You may access, correct, export (PDF) and delete your data under GDPR and Brazil's LGPD.",
          `For any privacy request, write to ${SUPPORT}.`,
        ]],
        ["Minors", [
          "The app is intended for people aged 18 or older. We do not knowingly collect data from minors.",
        ]],
        ["Security", [
          "Encrypted connections (HTTPS), bcrypt password hashing, httpOnly cookie sessions and private photo storage.",
        ]],
        ["Contact", [`Privacy questions: ${SUPPORT}`]],
      ],
    },
    terms: {
      title: "Terms of Use",
      updated: `Last updated: ${UPDATED}`,
      sections: [
        ["Acceptance", [
          "By creating an account and using Skinly Check you agree to these Terms and to the Privacy Policy.",
        ]],
        ["Nature of the service — not a medical diagnosis", [
          "The app only assesses aesthetic aspects visible in photos, with the support of artificial intelligence.",
          "The content is informational and educational. It does NOT replace medical, dermatological or nutritional consultation, diagnosis or treatment.",
          "Never start, stop or change any treatment based solely on an app report. Consult a healthcare professional.",
        ]],
        ["Content you upload", [
          "You confirm the photos are yours or that you have express permission from the person shown.",
          "Uploading nudity (exposed genitals, anus or nipples), sexual content, images of people under 18 or images of others without consent is prohibited.",
          "We recommend photos in swimwear or fitted clothing, in good lighting.",
          "Uploads that break these rules are refused and may lead to account termination.",
        ]],
        ["Your account", [
          "Access is personal and non-transferable. Keep your password confidential.",
          "You may delete your account and all of your data at any time inside the app.",
        ]],
        ["Limitation of liability", [
          "Assessments are generated by artificial intelligence from images and may contain inaccuracies.",
          "We are not liable for aesthetic, clinical or financial decisions made based on app content.",
        ]],
        ["Intellectual property", [
          "The Skinly Check name, brand, texts and software are protected. Your photos and data remain yours.",
        ]],
        ["Changes", [
          "We may update these Terms to reflect app improvements or legal requirements. The update date is always shown on this page.",
        ]],
        ["Contact", [`Support: ${SUPPORT}`]],
      ],
    },
  },
  es: {
    privacy: {
      title: "Política de Privacidad",
      updated: `Última actualización: ${UPDATED}`,
      sections: [
        ["Quiénes somos", [
          "Skinly Check es una aplicación de seguimiento estético para personas en tratamiento con medicamentos GLP-1. No somos un servicio médico y no ofrecemos diagnósticos.",
        ]],
        ["Datos que recopilamos", [
          "Registro: nombre, correo y contraseña (almacenada solo de forma cifrada).",
          "Medidas que tú informas: peso, altura e IMC.",
          "Fotos que subes para el análisis estético (rostro y/o cuerpo).",
          "Plataforma de compra (Hotmart o Kiwify) cuando tu cuenta se crea automáticamente tras la compra.",
        ]],
        ["Cómo usamos tus datos", [
          "Generar tus evaluaciones estéticas, informes y gráficos de evolución.",
          "Autenticar tu acceso y mantener tu sesión segura.",
          "Enviar correos operativos (activación de cuenta y restablecimiento de contraseña).",
          "Nunca vendemos ni alquilamos tus datos, y no usamos tus fotos para publicidad.",
        ]],
        ["Tratamiento de las fotos", [
          "Tus fotos se guardan en almacenamiento privado y solo son accesibles desde tu propia cuenta autenticada.",
          "Para generar el informe, las fotos se envían al proveedor de inteligencia artificial (OpenAI) únicamente para procesar ese análisis. No se usan para entrenar modelos.",
          "Puedes eliminar cualquier evaluación, o toda tu cuenta y fotos, en cualquier momento dentro de la app.",
          "No analizamos imágenes con desnudez ni imágenes de menores de 18 años. Esos envíos se rechazan automáticamente.",
        ]],
        ["Terceros", [
          "OpenAI — procesamiento del análisis de imágenes y textos.",
          "Resend — envío de correos transaccionales.",
          "Hotmart y Kiwify — confirmación de tu compra para crear el acceso.",
          "No compartimos datos más allá de lo estrictamente necesario para el funcionamiento de la app.",
        ]],
        ["Conservación y eliminación", [
          "Conservamos tus datos mientras exista tu cuenta.",
          "En Cuenta → Eliminar mi cuenta, todos tus datos (fotos, informes, registros de peso e IMC) se borran de forma permanente e inmediata.",
        ]],
        ["Tus derechos", [
          "Puedes acceder, corregir, exportar (PDF) y eliminar tus datos, conforme al GDPR y a la LGPD (Brasil).",
          `Para cualquier solicitud de privacidad, escribe a ${SUPPORT}.`,
        ]],
        ["Menores de edad", [
          "La aplicación está destinada a personas de 18 años o más. No recopilamos intencionadamente datos de menores.",
        ]],
        ["Seguridad", [
          "Conexiones cifradas (HTTPS), contraseñas con hash bcrypt, sesión por cookie httpOnly y fotos en almacenamiento privado.",
        ]],
        ["Contacto", [`Dudas sobre privacidad: ${SUPPORT}`]],
      ],
    },
    terms: {
      title: "Términos de Uso",
      updated: `Última actualización: ${UPDATED}`,
      sections: [
        ["Aceptación", [
          "Al crear tu cuenta y usar Skinly Check, aceptas estos Términos y la Política de Privacidad.",
        ]],
        ["Naturaleza del servicio — no es un diagnóstico médico", [
          "La app evalúa únicamente aspectos estéticos visibles en fotos, con apoyo de inteligencia artificial.",
          "El contenido es informativo y educativo. NO sustituye una consulta, diagnóstico o tratamiento médico, dermatológico o nutricional.",
          "Nunca inicies, interrumpas o cambies un tratamiento basándote solo en el informe de la app. Consulta a un(a) profesional de salud.",
        ]],
        ["Contenido que subes", [
          "Declaras que las fotos son tuyas o que cuentas con autorización expresa de la persona retratada.",
          "Está prohibido subir desnudez (genitales, ano o pezones expuestos), contenido sexual, imágenes de menores de 18 años o imágenes de terceros sin consentimiento.",
          "Recomendamos fotos con traje de baño o ropa ajustada y buena iluminación.",
          "Los envíos que incumplan estas reglas se rechazan y pueden derivar en el cierre de la cuenta.",
        ]],
        ["Tu cuenta", [
          "El acceso es personal e intransferible. Mantén tu contraseña en secreto.",
          "Puedes eliminar tu cuenta y todos tus datos en cualquier momento dentro de la app.",
        ]],
        ["Limitación de responsabilidad", [
          "Los análisis los genera una inteligencia artificial a partir de imágenes y pueden contener imprecisiones.",
          "No nos responsabilizamos por decisiones estéticas, clínicas o económicas tomadas con base en el contenido de la app.",
        ]],
        ["Propiedad intelectual", [
          "El nombre, la marca, los textos y el software de Skinly Check están protegidos. Tus fotos y datos siguen siendo tuyos.",
        ]],
        ["Cambios", [
          "Podemos actualizar estos Términos para reflejar mejoras de la app o requisitos legales. La fecha de actualización siempre se muestra en esta página.",
        ]],
        ["Contacto", [`Soporte: ${SUPPORT}`]],
      ],
    },
  },
};

export const legalDoc = (language, doc) => (LEGAL[(language || "pt").split("-")[0]] || LEGAL.pt)[doc];
